import React from 'react'
import AppButton from '../../../components/elements/AppButton'
import ReactPlayer from 'react-player'
import VideoFIle from '../../../assets/video/final.mp4';
import { useNavigate } from 'react-router-dom';

export default function WorksSection(props) {
    const navigate = useNavigate();
    const handleExploreClick = ()=>{
        navigate("/projects");
    }
    return (
        <div className='work-main'>
            <div className="work-vdo-con">
            <ReactPlayer
                className='avatar-react-player fixed-bottom'
                url= {VideoFIle}
                width={"100vw"}
                height={"103.5vh"}
                playing={true}     
                loop={true}
                muted={true}
                style={{
                    objectFit:"cover",
                    
                }}
                
              /> 
            </div>
            <div className='work-text-con'>
                <div style={{display:"flex",alignItems:"flex-end"}}>
                    <p className='work-head-text'>Discover<br/>MY PORTFLIO</p>
                    <AppButton onClick={handleExploreClick} style={{marginBottom:12}} title={"Explore"} />
                </div>
                <img className='work-favorate-img' src={require('../../../assets/images/favlabel.png')} />
            </div>
        </div>
    )
}
